import { CSSProperties } from 'react';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { BlueprintCardContent } from './BlueprintCardContent';
import { BlueprintCardHeader } from './BlueprintCardHeader';
import { BlueprintCardWrapper } from './BlueprintCardWrapper';

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      flexBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
      },
    }),
  { name: 'blueprintCard' },
);

export const BlueprintSkeleton = (props: {
  style?: CSSProperties;
  className?: string;
  loading?: boolean;
}) => {
  const { style, className, loading } = props;

  const classes = useStyles();

  return (
    <BlueprintCardWrapper className={className} style={style}>
      <BlueprintCardHeader loading={loading} />
      <BlueprintCardContent>
        <Skeleton animation={!loading && loading} />

        <Box className={classes.flexBox}>
          <Skeleton animation={!loading && loading} />
          <Skeleton animation={!loading && loading} />
        </Box>
      </BlueprintCardContent>
    </BlueprintCardWrapper>
  );
};
